import $ from "jquery";
import "magnific-popup";
import "./classes/polyfills.class.js";
import AnchorScroller from "./classes/anchor-scroller";
import AOS from "aos";
import CollapsibleItem from "./classes/collapsible-item.class.js";
import FixedHeader from "./classes/fixed-header.class";
import FixedIsi from "./classes/fixed-isi.js";
import FormBehavior from "./classes/form-behavior.class.js";
import MainMenu from "./classes/main-menu.class.js";
import Carousel from "./classes/carousel.class.js";
import Modal from "./classes/modal.class.js";
import Interstitial from "./classes/interstitial.class.js";
import Violator from "./classes/violator.class";
import PetriDish from "./classes/petri-dish.js";
import Player from "@vimeo/player";
import Lenis from "lenis";
import EmblaCarousel from "embla-carousel";
import AutoScroll from "embla-carousel-auto-scroll";

import gsap from "gsap";
import { ScrollTrigger, ScrollToPlugin, Flip } from "gsap/all";
import { WebGLFungus } from "./classes/webgl-fungus.js";
import Cursor from "./classes/cursor.js";
import { Incandecence } from "./classes/iridesence.class.js";
import { ImageDissolver } from "./classes/image-dissolver.class.js";
import ModalPlayer from "./classes/modal-player.class.js";

const isLayoutBuilder =
	!!$(".node-page-layout-builder-form").length ||
	!!$(".layout-builder__layout").length ||
	$(".__is-layout-builder").length;
const isHomePage = window.location.pathname === "/";
const isWhatWeDoPage = window.location.pathname.includes("what-we-do");
const isPetSecretsPage =
	(document.querySelector(".case-studies-pet-secrets") &&
		window.location.pathname.includes("pet-secrets")) ||
	(document.querySelector(".case-studies-wisdom-panel") &&
		window.location.pathname.includes("wisdom-panel"));
const isRedThreadPage =
	(document.querySelector(".case-studies-red-thread") &&
		window.location.pathname.includes("red-thread")) ||
	(document.querySelector(".case-studies-csl-behring") &&
		window.location.pathname.includes("csl-behring"));
const isPrivacyPolicyPage = window.location.pathname.includes("privacy-policy");
const isTermsOfUsePage = window.location.pathname.includes("terms-of-use");
const isOutnumberedPage = document.querySelector(".case-studies-valneva");

const lenis = new Lenis();

const mobileResolution = 1024;

const header = document.querySelector(".layout-container > header");
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Flip);
// Lenis scrolls programmatically, so the menu's overflow lock alone cannot
// stop it; halt it directly while the menu is open.
window.addEventListener("main-menu-toggle", (e) => {
	if (e.detail.open) {
		lenis.stop();
	} else {
		lenis.start();
	}
});

lenis.on("scroll", (e) => {
	ScrollTrigger.update();

	// if scrollTop > 0 add class to body
	if (isOutnumberedPage || isLayoutBuilder) return;
	if (lenis.scroll > 20) {
		document.body.classList.add("is-scrolling-h");
		!$(".node-page-layout-builder-form").length &&
			header.classList.add("is-scrolling-h");
	} else {
		document.body.classList.remove("is-scrolling-h");
		!$(".node-page-layout-builder-form").length &&
			header.classList.remove("is-scrolling-h");
	}
});
gsap.ticker.add((time) => {
	lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

if (isLayoutBuilder) {
	lenis.destroy();
}

// Initialize Animate on Scroll
AOS.init({
	duration: 1200,
});

// Initialize AnchorScroller
const scroll = new AnchorScroller(
	$("header[role=banner]").height(),
	$("header[role=banner]").height(),
	768);
scroll.init();

$(window)
	.on("resize", function () {
		if ($("html").hasClass("enable_sticky_desktop")) {
			scroll.desktopOffset = $("header[role=banner]").height();
		}

		if ($("html").hasClass("enable_sticky_desktop")) {
			scroll.mobileOffset = $("header[role=banner]").height();
		}
	})
	.trigger("resize");

// Initialize Modal Class
new Modal();



$(() => {

	// Initialize Interstitials
	new Interstitial();

	// Prevent scroll to modal after click
	$("a").each(function () {
		const href = $(this).attr("href");

		if (typeof href !== "undefined" && href.startsWith("#") && href !== "#") {
			const $target = $(href);
			if ($target.length && $target.hasClass("block--type--modal")) {
				$(this).on("click", (e) => e.stopImmediatePropagation());
			}
		}
	});

	const isi = document.querySelector(".isi .fixed");
	if (isi) {
		new FixedIsi();
	}

	const violator = document.querySelector(".violator");
	if (violator) {
		new Violator(violator);
	}

	new FixedHeader();

	const mainMenu = document.querySelector(".layout-container > header");
	if (mainMenu) {
		new MainMenu(mainMenu);
	}

	const caseStudyContainer = document.querySelectorAll(
		".layout--case-study-section"
	);
	if (caseStudyContainer.length) {
		caseStudyContainer.forEach((container) => {
			const backgroundWrapper = container.querySelector(
				".block--type--background"
			);
			if (!backgroundWrapper) return;

			const backgroundUrl = backgroundWrapper.dataset.backgroundImage || "";
			const backgroundCss = backgroundWrapper.dataset.backgroundCss || "";

			let bgImageValue = "";

			if (backgroundCss.includes("gradient") && backgroundUrl) {
				bgImageValue = `${backgroundCss}, url('${backgroundUrl}')`;
			} else if (backgroundCss.includes("gradient")) {
				bgImageValue = backgroundCss;
			} else if (backgroundUrl) {
				bgImageValue = `url('${backgroundUrl}')`;
			}

			if (backgroundCss) {
				container.style.background = backgroundCss || "";
			}

			if (bgImageValue) {
				container.style.backgroundImage = bgImageValue;
				container.style.backgroundSize = "cover";
				container.style.backgroundPosition = "top center";
				container.style.backgroundRepeat = "no-repeat";
			}
		});
	}

	// Don't active slideshows on the Layout Builder page
	if (
		$(".block--type--carousel-slide").length &&
		!$(".node-page-layout-builder-form").length
	) {
		$.uniqueSort($(".block--type--carousel-slide").parents(".layout__region"))
			.css({
				"min-width": 0,
			})
			.each(function () {
				new Carousel(this);
			});
	}

	document.querySelectorAll(".webform-submission-form").forEach((f) => {
		new FormBehavior(f);
	});

	document
		.querySelectorAll(".block--type--collapsible-item")
		.forEach((item) => {
			new CollapsibleItem(item);
		});

	if ($(".popup-youtube").length) {
		$(".popup-youtube").magnificPopup({
			type: "iframe",
			iframe: {
				patterns: {
					youtube: {
						index: "youtube.com/",
						id: "v=",
						src: "//www.youtube-nocookie.com/embed/%id%?autoplay=1&modestbranding=1",
					},
				},
			},
			mainClass: "mfp-fade",
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
		});
	}

	if (!isLayoutBuilder) {
		// Tabs
		const brandTabs = document.querySelectorAll(".brand-tab");
		if (brandTabs.length) {
			const brandContents = document.querySelectorAll(".brand-content");
			const timers = document.querySelectorAll(".timer-progress");

			let currentTabIndex = 0;
			let currentSlideIndex = 0;
			let slideInterval;
			let tabInterval;
			const SLIDE_DURATION = 6000;

			function activateTab(tabIndex) {
				brandTabs.forEach((tab, i) => {
					const isActive = i === tabIndex;
					tab.classList.toggle("active", isActive);
					tab.setAttribute("aria-expanded", isActive ? "true" : "false");
					if (brandContents[i]) {
						brandContents[i].classList.toggle("active", isActive);
					}
				});

				timers.forEach((timer) => {
					const r = timer.r.baseVal.value;
					const circumference = 2 * Math.PI * r;
					timer.style.strokeDasharray = circumference;
					timer.style.strokeDashoffset = circumference;
				});

				const timer = timers[tabIndex];
				if (timer) {
					const r = timer.r.baseVal.value;
					const circumference = 2 * Math.PI * r;
					timer.animate(
						[{ strokeDashoffset: circumference }, { strokeDashoffset: 0 }],
						{
							duration: getTabDuration(tabIndex),
							easing: "linear",
							fill: "forwards",
						}
					);
				}

				currentTabIndex = tabIndex;
				currentSlideIndex = 0;
				startSlides(tabIndex);
			}

			function activateSlide(tabIndex, slideIndex) {
				const brandSlider =
					brandContents[tabIndex].querySelector(".brand-slider");
				const brandSlides =
					brandContents[tabIndex].querySelectorAll(".brand-slide");
				if (!brandSlider || !brandSlides.length) return;

				const slideWidth = brandSlides[0].offsetWidth;
				brandSlider.scrollTo({
					left: slideWidth * slideIndex,
					behavior: "smooth",
				});

				currentSlideIndex = slideIndex;
			}

			function getTabDuration(tabIndex) {
				const slides = brandContents[tabIndex].querySelectorAll(".brand-slide");
				return slides.length * SLIDE_DURATION;
			}

			function startSlides(tabIndex) {
				clearInterval(slideInterval);
				const slides = brandContents[tabIndex].querySelectorAll(".brand-slide");
				if (!slides.length) return;

				activateSlide(tabIndex, 0);

				slideInterval = setInterval(() => {
					let nextSlide = (currentSlideIndex + 1) % slides.length;
					activateSlide(tabIndex, nextSlide);
				}, SLIDE_DURATION);

				clearTimeout(tabInterval);
				tabInterval = setTimeout(() => {
					let nextTab = (currentTabIndex + 1) % brandTabs.length;
					activateTab(nextTab);
				}, getTabDuration(tabIndex));
			}

			brandTabs.forEach((tab, i) => {
				tab.addEventListener("click", () => {
					clearInterval(slideInterval);
					clearTimeout(tabInterval);
					activateTab(i);
				});
			});

			activateTab(0);
		}

		if (isHomePage) {
			// Petri Dish animation
			const dish = new PetriDish();
			// dish.setupPanel()

			window.setupPanel = () => dish.setupPanel();
			window.disablePanel = () => dish.disablePanel();

			// Selectors
			const reelsBox = document.querySelector(".reels-box");
			const reelsVideo = document.querySelector(".reels-video");
			const homePageWrapper = document.querySelector(".homepage-initial");
			const petriDishEl = document.querySelector(".petri-dish");
			const growArea = homePageWrapper.querySelector(".grow-area");
			const brothLogo = homePageWrapper.querySelector(".broth-logo");
			const copy = homePageWrapper.querySelector(".grow-area-copy");
			const webGlCopy = homePageWrapper.querySelector(".webgl-container-copy");

			const player = new Player(reelsVideo);
			// GSAP Animations

			const initialScale = 720;
			const finalScale = 1128;
			const finalScale2 = 1440;
			const scaleFactor = finalScale / initialScale;
			const scaleFactor2 = finalScale2 / initialScale;

			const mobileInitialScale = 350;
			const mobileFinalScale = 677;
			const mobileFinalScale2 = 718;
			const mobileScaleFactor = mobileFinalScale / mobileInitialScale;
			const mobileScaleFactor2 = mobileFinalScale2 / mobileInitialScale;

			const copyTl = gsap.timeline({ paused: true });
			const reelsCopy = document.querySelectorAll(".reels-copy");
			const reelsCopyMobile = document.querySelector(
				".reels-copy_wrapper.mobile"
			);
			const reelsCopyMobileIcons = reelsCopyMobile.querySelectorAll(".image");

			const mm = gsap.matchMedia();

			// desktop only
			reelsCopy.forEach((el, index) => {
				const dots = el.querySelectorAll(".dot");
				const image = el.querySelector(".image");
				const text = el.querySelector("p");

				dots.forEach((dot, dotIndex) => {
					copyTl.to(
						dot,
						{ x: -10, opacity: 1, duration: 0.3, ease: "power1.out" },
						index * 0.1,
					);
				});
				copyTl.to(
					image,
					{ x: -10, opacity: 1, duration: 0.3, ease: "power1.out" },
					index * 0.2,
				);
				copyTl.to(
					text,
					{ x: -10, opacity: 1, duration: 0.3, ease: "power1.out" },
					index * 0.3,
				);
			});

			const webGlCopyTl = gsap.timeline({ paused: true });
			webGlCopyTl.to(".webgl-container-copy p", {
				y: -10,
				opacity: 1,
				duration: 0.3,
				ease: "power1.out",
			});
			webGlCopyTl.to(
				".webgl-container-copy h3",
				{ y: 10, opacity: 1, duration: 0.3, ease: "power1.out" },
				">",
			);

			const brothCopyTl = gsap.timeline({ paused: true });
			brothCopyTl.to(brothLogo, {
				opacity: 1,
				duration: 0.3,
				ease: "power1.out",
			});
			brothCopyTl.to(
				copy,
				{ opacity: 1, duration: 0.3, ease: "power1.out" },
				">",
			);
			brothCopyTl.to(
				".scroll-down-copy",
				{ opacity: 1, duration: 0.3, ease: "power1.out" },
				">",
			);

			const masterTimeline = gsap.timeline();
			masterTimeline.addLabel("startCopy", 5);
			masterTimeline.addLabel("reverseCopy", 6);

			// First Part of the scroll - from 0 to 500vh
			masterTimeline.to({}, { duration: 1 });

			// desktop only
			const petriSlot = gsap.timeline();
			masterTimeline.add(petriSlot, ">");
			// mm.add(`(min-width: ${mobileResolution + 1}px)`, ()=> {
			//   petriSlot.clear().to(petriDishEl, {
			//     scale: scaleFactor,
			//     // rotate: -360,
			//     left: "-81%",
			//     transformOrigin: "center center",
			//     ease: "none",
			//     duration: 5
			//   }, 0);
			// });

			mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
				petriSlot.clear().to(
					petriDishEl,
					{
						keyframes: [
							{
								scale: scaleFactor,
								duration: 10,
								ease: "power2.out",
							},
							{
								left: "-81%",
								duration: 10,
								ease: "power2.inOut",
							},
						],
						transformOrigin: "center center",
					},
					0,
				);
			});

			mm.add(`(max-width: ${mobileResolution}px)`, () => {
				const availableHeight = window.innerHeight - 260;
				const scaledHeight = mobileInitialScale * mobileScaleFactor;

				let factor =
					scaledHeight > availableHeight ? availableHeight / scaledHeight : 1;

				factor = Math.min(factor * 1.2, 1);

				petriSlot.clear().to(
					petriDishEl,
					{
						scale: mobileScaleFactor * factor,
						// rotate: -360,
						left: "-47%",
						top: "-34%",
						transformOrigin: "center center",
						ease: "none",
						duration: 10,
					},
					0,
				);
			});

			// Animate copy in the middle of the first part duration 1
			masterTimeline.to({}, { duration: 5 }, ">");

			masterTimeline.to({}, { duration: 5 }, ">");

			// Second Part of the scroll - from 1000vh to 1500vh - go back to center
			const petriSlot2 = gsap.timeline();
			masterTimeline.add(petriSlot2, ">");

			mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
				petriSlot2.clear().to(
					petriDishEl,
					{
						scale: 1,
						// rotate: 360,
						left: "0",
						transformOrigin: "center center",
						ease: "none",
						duration: 20,
					},
					0,
				);
			});

			mm.add(`(max-width: ${mobileResolution}px)`, () => {
				petriSlot2.clear().to(
					petriDishEl,
					{
						scale: 1,
						// rotate: 360,
						left: "0",
						top: "0",
						transformOrigin: "center center",
						ease: "none",
						duration: 10,
					},
					0,
				);
			});

			// Third part of the scroll - from 1500vh to 3600vh - scale up
			const petriSlot3 = gsap.timeline();
			masterTimeline.add(petriSlot3, ">");

			mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
				petriSlot3.clear().to(
					[".grow-area canvas", petriDishEl],
					{
						duration: 20,
						ease: "power1.inOut",
						transformOrigin: "center center",
						rotation: (i, target) => (target === petriDishEl ? -5 : 5),
						scale: (i, target) => (target === petriDishEl ? scaleFactor2 : 1),
					},
					0,
				);
			});

			mm.add(`(max-width: ${mobileResolution}px)`, () => {
				petriSlot3.clear().to(
					[".grow-area canvas", petriDishEl],
					{
						duration: 20,
						top: 54,
						ease: "power1.inOut",
						transformOrigin: "center center",
						rotation: (i, target) => (target === petriDishEl ? -5 : 5),
						scale: (i, target) =>
							target === petriDishEl ? mobileScaleFactor2 : 1,
					},
					0,
				);
			});

			masterTimeline.to({}, { duration: 5 }, ">");
			let isScrollBlocked = false;
			let openGl = null;
			const mainSt = ScrollTrigger.create({
				trigger: homePageWrapper,
				start: "top top",
				end: "+=5400vh",
				scrub: true,
				pin: true,
				animation: masterTimeline,
				onUpdate: async (self) => {
					const isMobile = window.innerWidth < 1024;
					// console.log(self.progress);
					if (isMobile) {
						const dots = document.querySelectorAll(
							".reels-copy_wrapper.mobile .dot",
						);
						const images = document.querySelectorAll(
							".reels-copy_wrapper.mobile .image",
						);
						const texts = document.querySelectorAll(
							".reels-copy_wrapper.mobile .copy-text p",
						);
						let activeIndex = -1;

						if (self.progress >= 0.1 && self.progress < 0.2) activeIndex = 0;
						if (self.progress >= 0.2 && self.progress < 0.3) activeIndex = 1;
						if (self.progress >= 0.3 && self.progress < 0.4) activeIndex = 2;

						dots.forEach((d) => d.classList.remove("active"));
						images.forEach((img, index) => {
							img.classList.remove("active");
							img.addEventListener("click", () => {
								if (index === 0) {
									gsap.to(window, {
										scrollTo: mainSt.start + (mainSt.end - mainSt.start) * 0.12,
										duration: 1,
										ease: "power2.out",
									});
								}

								if (index === 1) {
									gsap.to(window, {
										scrollTo: mainSt.start + (mainSt.end - mainSt.start) * 0.22,
										duration: 1,
										ease: "power2.out",
									});
								}

								if (index === 2) {
									gsap.to(window, {
										scrollTo: mainSt.start + (mainSt.end - mainSt.start) * 0.32,
										duration: 1,
										ease: "power2.out",
									});
								}
							});
						});
						texts.forEach((t) => t.classList.remove("active"));
						if (activeIndex >= 0) {
							reelsCopyMobile.style.opacity = 1;
							reelsCopyMobile.style.pointerEvents = "auto";
							dots[activeIndex].classList.add("active");
							images[activeIndex].classList.add("active");
							texts[activeIndex].classList.add("active");
						} else {
							reelsCopyMobile.style.pointerEvents = "none";
							gsap.to(reelsCopyMobile, {
								opacity: 0,
								duration: 0.3,
								ease: "power1.out",
							});
						}
					}

					if (isMobile && self.progress > 0.022) {
						brothCopyTl.reverse();
					} else if (self.progress > 0.04) {
						brothCopyTl.reverse();
					} else {
						brothCopyTl.play();
					}

					if (self.progress >= (isMobile ? 0.1 : 0.0289)) {
						growArea.classList.add("moved");
						dish.inactivate();
						gsap.to(".reels-box", {
							pointerEvents: "none",
							opacity: 0,
							duration: 0.3,
							ease: "power1.out",
						});
						gsap.to(".supreme-popup", {
							pointerEvents: "none",
							opacity: 0,
							duration: 0.3,
							ease: "power1.out",
						});
					} else {
						growArea.classList.remove("moved");
						dish.activate();
						gsap.to(".reels-box", {
							pointerEvents: "auto",
							opacity: 1,
							duration: 0.3,
							ease: "power1.out",
						});
						gsap.to(".supreme-popup", {
							pointerEvents: "auto",
							opacity: 1,
							duration: 0.3,
							ease: "power1.out",
						});
					}

					if (self.progress <= 0.0645) {
						copyTl.pause();
						copyTl.progress(0);
					}

					if (
						(isMobile && self.progress >= 0.14 && self.progress <= 0.4) ||
						(self.progress >= 0.28 && self.progress <= 0.5)
					) {
						if (!isScrollBlocked) {
							lenis.stop();
							setTimeout(() => {
								lenis.start();
							}, 500);
						}
						isScrollBlocked = true;

						growArea.classList.add("video-added");
						player.play();
						copyTl.play();
						petriDishEl.classList.add("gradient");
						growArea.classList.remove("visible");

						return;
					}

					if (self.progress < 0.28) {
						growArea.classList.remove("video-added");
						player.pause();
						player.setCurrentTime(0);
						petriDishEl.classList.remove("gradient");
						copyTl.reverse();
						growArea.classList.remove("openGl-active");
						if (!dish.isInside) {
							dish.isInside = true;
							dish.lastMoveTs = Date.now() + 2000;
							dish.stopIdle();
						}
					}

					if (self.progress >= 0.5) {
						player.pause();
						player.setCurrentTime(0);
						petriDishEl.classList.remove("gradient");
						petriDishEl.classList.add("bigger");
						copyTl.reverse();

						growArea.classList.add("visible");
						if (!growArea.classList.contains("openGl-active")) {
							growArea.classList.add("openGl-active");
							openGl = new Incandecence({
								color: [0.5, 0.6, 0.8],
								speed: 1.0,
								amplitude: 0.15,
								mouseReact: true,
								background: [1, 1, 1, 1],
							});
							window.openGl = openGl;
							growArea.appendChild(openGl);
						}
					} else {
						petriDishEl.classList.remove("bigger");
					}

					if (self.progress >= 0.76) {
						webGlCopyTl.play();
					} else {
						webGlCopyTl.reverse();
					}
				},
			});

			// target
			const st = ScrollTrigger.create({
				trigger: ".video-background-section",
				start: "top top",
				end: "+=200vh",
				scrub: true,
				pin: true,
			});

			// Video Reels box on hover

			if (reelsBox && reelsVideo) {
				player.pause();

				reelsBox.addEventListener("mouseenter", () => {
					reelsBox.classList.add("playing");
					player.play();
				});

				reelsBox.addEventListener("mouseleave", () => {
					reelsBox.classList.remove("playing");
					player.pause();
					player.setCurrentTime(0);
				});
			}

			const modalPlayer1 = new ModalPlayer(reelsVideo.src, ".eye-button");
			const modalPlayer2 = new ModalPlayer(
				reelsVideo.src,
				".reels-box .image-wrapper",
			);
			const modalPlayer3 = new ModalPlayer(
				reelsVideo.src,
				".petri-dish-video-wrapper",
			);
		}
	}

	if (isWhatWeDoPage) {
		const reelsBox = document.querySelector(".reels-box");
		const reelsVideo = document.querySelector(".reels-video");
		const player = new Player(reelsVideo);

		if (reelsBox && reelsVideo) {
			new ModalPlayer(reelsVideo.src, ".reels-box .image-wrapper");

			player.pause();

			reelsBox.addEventListener("mouseenter", () => {
				reelsBox.classList.add("playing");
				player.play();
			});

			reelsBox.addEventListener("mouseleave", () => {
				reelsBox.classList.remove("playing");
				player.pause();
				player.setCurrentTime(0);
			});
		}
	}
	const pushWaveSvg = document.getElementById("pushWave");
	if (pushWaveSvg) {
		const svgWrapper = document.querySelector(
			".liquid-hero .layout__region.layout__region--content",
		);
		const cursor = new Cursor(svgWrapper);
		const path = document.getElementById("pushPath");
		const VW = 1000,
			VH = 200;
		const mobileQuery = window.matchMedia(
			`(max-width: ${mobileResolution}px)`,
		);
		const reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;

		// One easing constant for entry, tracking, and exit. The old code drew
		// the pointer's geometry directly and only eased on mouseleave, so the
		// bump appeared fully formed in a single frame - the "snappy" the
		// designer flagged - while the exit glided. Everything now chases a
		// target at the exit's own pace.
		const SPEED = 0.08;
		const centerX = VW / 2;
		let currentX = centerX;
		let currentAmp = 0;
		let targetX = centerX;
		let targetAmp = 0;
		let waveRAF = null;

		function drawWave(x, amp) {
			const spread = mobileQuery.matches ? VW * 0.2 : 130;
			const s2 = 2 * spread * spread;
			const points = 50;
			const step = VW / (points - 1);

			let d = `M 0 0 `;
			for (let i = 0; i < points; i++) {
				const vx = i * step;
				const g = Math.exp(-((vx - x) * (vx - x)) / s2);
				const vy = amp * g;
				d += `L ${vx} ${vy}`;
			}

			d += `L ${VW} 0`;
			d += `L 0 0 Z`;

			path.setAttribute("d", d);
		}
		window.drawWave = drawWave;

		function stepWave() {
			currentX += (targetX - currentX) * SPEED;
			currentAmp += (targetAmp - currentAmp) * SPEED;

			drawWave(currentX, currentAmp);

			if (
				Math.abs(targetX - currentX) > 0.3 ||
				Math.abs(targetAmp - currentAmp) > 0.3
			) {
				waveRAF = requestAnimationFrame(stepWave);
			} else {
				currentX = targetX;
				currentAmp = targetAmp;
				drawWave(currentX, currentAmp);
				waveRAF = null;
			}
		}

		function setWaveTarget(x, amp) {
			targetX = x;
			targetAmp = amp;
			if (!waveRAF) waveRAF = requestAnimationFrame(stepWave);
		}

		pushWaveSvg.setAttribute("viewBox", `0 0 ${VW} ${VH}`);
		drawWave(centerX, 0);

		if (!reducedMotion) {
			svgWrapper.addEventListener("mousemove", (e) => {
				if (mobileQuery.matches) return;

				const box = svgWrapper.getBoundingClientRect();
				const x = ((e.clientX - box.left) / box.width) * VW;

				const distFromTop = e.clientY - box.top;
				const amp = 80 * (distFromTop / box.height);

				setWaveTarget(x, amp);
			});

			svgWrapper.addEventListener("mouseleave", () => {
				if (mobileQuery.matches) return;
				setWaveTarget(centerX, 0);
			});

			// Crossing the breakpoint used to freeze the effect until reload,
			// because the flag was captured once at load.
			mobileQuery.addEventListener("change", () => {
				setWaveTarget(centerX, 0);
			});
		}

		function orientationHandler(event) {
			if (!mobileQuery.matches || reducedMotion) return;

			const gamma = event.gamma || 0;

			const x = ((gamma + 90) / 180) * VW;

			setWaveTarget(x, 60);
		}

		function initDeviceOrientation() {
			if (
				typeof DeviceMotionEvent !== "undefined" &&
				typeof DeviceMotionEvent.requestPermission === "function"
			) {
				DeviceMotionEvent.requestPermission()
					.then((response) => {
						if (response === "granted") {
							window.addEventListener("deviceorientation", orientationHandler);
						}
					})
					.catch(console.error);
			} else {
				window.addEventListener("deviceorientation", orientationHandler);
			}
		}

		const isIos =
			/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isIos) {
			// document.body.addEventListener("click", initDeviceOrientation, {
			// 	once: true,
			// });
			drawWave(VW / 2, 60);
		} else {
			initDeviceOrientation();
		}
	}
	const infinityGallery = document.querySelector(".infinity-gallery");

	if (infinityGallery) {
		const emblaNode = document.querySelector(".scroller");
		if (!emblaNode) {
			console.warn("Embla node not found");
			return;
		}
		const scrollerInner = emblaNode.querySelector(".scroller__inner");
		const scrollerContent = Array.from(scrollerInner.children);

		scrollerContent.forEach((item) => {
			const duplicatedItem = item.cloneNode(true);
			scrollerInner.appendChild(duplicatedItem);
		});
		const options = { loop: true };
		const plugins = [
			AutoScroll({
				startDelay: 0,
				stopOnMouseEnter: true,
				stopOnInteraction: false,
				speed: 1,
			}),
		];
		const emblaApi = EmblaCarousel(emblaNode, options, plugins);
		window.carouselh = emblaApi;
	}
	const studyCases = document.querySelectorAll(".study-case__wrapper");

	if (studyCases.length && !isLayoutBuilder) {
		studyCases.forEach((wrapper) => {
			const videoDiv = wrapper.querySelector(".video-url");
			const imageDiv = wrapper.querySelector(".study-case_image");
			const contentUrl = wrapper.querySelector(".study-case_btn a").href;

			const videoUrl = videoDiv ? videoDiv.textContent.trim() : "";

			// The poster image describes the film; a generic "vimeo-player"
			// left every one of these with the same accessible name.
			const posterAlt = imageDiv && imageDiv.querySelector("img")
				? imageDiv.querySelector("img").alt
				: "";

			// Every card carries an empty .video-url div whether or not the
			// study has a film. Without this guard the empty string built an
			// iframe pointing at the current page.
			if (videoDiv && videoUrl) {
				// Most films are on Vimeo, but End ALS is self-hosted, so the
				// element and the play/pause calls differ.
				const isSelfHosted = /\.(mp4|webm)(\?|#|$)/i.test(videoUrl);
				let media;
				let play;
				let pause;

				if (isSelfHosted) {
					media = document.createElement("video");
					media.src = videoUrl;
					media.muted = true;
					media.loop = true;
					media.playsInline = true;
					// Nothing downloads until the card is hovered.
					media.preload = "none";
					media.setAttribute("aria-label", posterAlt || "Case study video");
					play = () =>
						media.play().catch((err) => console.warn("Error on play:", err));
					pause = () => media.pause();
				} else {
					media = document.createElement("iframe");
					// The stored URLs already carry ?h=...; a second ? would fold
					// every following parameter into the h value.
					const joiner = videoUrl.includes("?") ? "&" : "?";
					media.src = `${videoUrl}${joiner}background=1&autoplay=1&muted=1&loop=1&controls=0&byline=0&title=0&playsinline=1&dnt=1`;
					media.title = posterAlt || "Case study video";
					media.setAttribute("frameborder", "0");
					media.setAttribute(
						"referrerpolicy",
						"strict-origin-when-cross-origin",
					);
					media.setAttribute(
						"allow",
						"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
					);
					media.allowFullscreen = true;
				}

				videoDiv.innerHTML = "";
				videoDiv.appendChild(media);
				videoDiv.classList.remove("hidden");

				if (!isSelfHosted) {
					const player = new Player(media);
					play = () =>
						player.play().catch((err) => console.warn("Error on play:", err));
					pause = () => player.pause();
				}

				imageDiv.addEventListener("mouseenter", () => {
					imageDiv.classList.add("hovered");
					play();
					media.classList.add("is-active");
				});

				imageDiv.addEventListener("mouseleave", () => {
					imageDiv.classList.remove("hovered");
					pause();
					media.classList.remove("is-active");
				});

				imageDiv.addEventListener("click", () => {
					window.location.href = contentUrl;
				});
			}

			let image = wrapper.querySelector(".study-case_image");
			let content = wrapper.querySelector(".study-case_content");

			const mm = gsap.matchMedia();
			mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
				gsap.fromTo(
					image,
					{ y: -50 },
					{
						y: 50,
						ease: "none",
						scrollTrigger: {
							trigger: wrapper,
							start: "top bottom",
							end: "bottom top",
							scrub: true,
						},
					},
				);

				gsap.fromTo(
					content,
					{ y: 10 },
					{
						y: 0,
						ease: "none",
						scrollTrigger: {
							trigger: wrapper,
							start: "top 80%",
							end: "bottom 20%",
							scrub: true,
						},
					},
				);
			});
		});
	}

	// Animations
	const glassContents = document.querySelectorAll(".glass-content");
	const gmm = gsap.matchMedia();
	if (glassContents.length && !isLayoutBuilder) {
		glassContents.forEach((content) => {
			gmm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
				gsap.fromTo(
					content,
					{ y: 50 },
					{
						y: 0,
						ease: "none",
						scrollTrigger: {
							trigger: content,
							start: "top 90%",
							end: "bottom 70%",
							scrub: true,
						},
					},
				);
			});
		});
	}

	const videoSection = document.querySelector(".video-section");
	if (videoSection) {
		const isMoveGbsForwardPage =
			document.querySelector(".case-studies-move-gbs-forward") ||
			document.querySelector(".case-studies-annexon");

		const image = videoSection.querySelector("img");
		const iframe = videoSection.querySelector("iframe");
		const player = new Player(iframe);

		videoSection.addEventListener("click", () => {
			const isPlaying = videoSection.classList.contains("active");
			if (isPlaying) return;

			setTimeout(() => {
				player.play().catch((e) => {
					console.log("error", e);
				});
			}, 300);

			videoSection.classList.add("active");
			gsap.to(image, {
				opacity: 0,
				duration: 0.6,
				ease: "power2.out",
				onComplete: () => {
					image.style.pointerEvents = "none";
				},
			});

			gsap.to(iframe, {
				opacity: 1,
				duration: 0.6,
				ease: "power2.inOut",
				onStart: () => {
					iframe.style.pointerEvents = "auto";
					player.play();
				},
			});
		});

		player.on("play", () => {
			if (isMoveGbsForwardPage) return;
			player.setVolume(1);
		});

		player.on("ended", () => {
			player.setCurrentTime(0);
			videoSection.classList.remove("active");
			gsap.to(iframe, {
				opacity: 0,
				duration: 0.6,
				ease: "power2.out",
				onComplete: () => {
					iframe.style.pointerEvents = "none";
				},
			});
			gsap.to(image, {
				opacity: 1,
				duration: 0.6,
				ease: "power2.inOut",
				onStart: () => {
					image.style.pointerEvents = "auto";
				},
			});
		});

		if (isMoveGbsForwardPage) {
			player.ready().then(() => {
				player.setMuted(true);

				gsap.to(image, {
					opacity: 0,
					duration: 0.6,
					ease: "power2.out",
					onComplete: () => {
						image.style.pointerEvents = "none";
						videoSection.classList.add("active");
					},
				});

				gsap.to(iframe, {
					opacity: 1,
					duration: 0.6,
					ease: "power2.inOut",
					onStart: () => {
						iframe.style.pointerEvents = "auto";
					},
					onComplete: () => {
						player
							.play()
							.then(() => {
								console.log("Vimeo autoplaying muted video");
							})
							.catch((err) => {
								console.warn("Vimeo blocked autoplay:", err);
							});
					},
				});
			});
		}
	}

	const highlightedCarousel = document.querySelector(
		".image-carousel-with-hightlighted",
	);
	if (highlightedCarousel) {
		const activeWrapper = highlightedCarousel.querySelector(".active-item");
		const inactiveWrapper =
			highlightedCarousel.querySelector(".inactive-items");

		inactiveWrapper.addEventListener("click", (e) => {
			const clickedImg = e.target.closest("img");
			if (!clickedImg) return;

			const clickedWrapper = clickedImg.parentElement.parentElement;
			const activeImg = activeWrapper.querySelector("img");
			if (!activeImg) return;

			const activeWrapperDiv = activeImg.parentElement.parentElement;

			if (!clickedWrapper || !activeWrapperDiv) return;

			inactiveWrapper.appendChild(activeWrapperDiv);
			activeWrapper.appendChild(clickedWrapper);

			gsap.fromTo(
				activeWrapperDiv,
				{ scale: 0.7, opacity: 0 },
				{ scale: 1, opacity: 1, duration: 0.6, ease: "power2.out" },
			);

			gsap.fromTo(
				clickedWrapper,
				{ scale: 0.7 },
				{ scale: 1, duration: 0.6, ease: "power2.out" },
			);
		});
	}

	gsap.to(".icon-container .icon-wrapper", {
		scrollTrigger: {
			trigger: ".icon-container",
			start: "top 80%",
			toggleActions: "play none none none",
		},
		y: 0,
		opacity: 1,
		duration: 1,
		ease: "power2.out",
		stagger: 0.3,
	});

	gsap.utils.toArray(".next-up-preview").forEach((preview, i) => {
		gsap.to(preview, {
			scrollTrigger: {
				trigger: preview,
				start: "top 80%",
				toggleActions: "play none none none",
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: "power2.out",
			delay: i * 0.2,
		});
	});

	// Page Specific
	if (isOutnumberedPage && !isLayoutBuilder) {
		document.body.classList.add("is-scrolling-h");
		header.classList.add("is-scrolling-h");

		const mm = gsap.matchMedia();

		gsap.from(".hero div", {
			y: 100,
			opacity: 0,
			duration: 1.2,
			ease: "power3.out",
			scrollTrigger: {
				trigger: ".hero",
				start: "top 80%",
				toggleActions: "play none none none",
			},
		});

		mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
			const aedes = document.querySelectorAll(
				"#aedes > div div:last-of-type img",
			);
			const valneva = document.querySelectorAll(
				"#valneva > div div:last-of-type img",
			);

			gsap.fromTo(
				aedes,
				{ y: -50 },
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: aedes,
						start: "top 90%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);

			gsap.fromTo(
				valneva,
				{ y: -10 },
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: valneva,
						start: "top 90%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);

			// Hero bg
			gsap.fromTo(
				".first-section",
				{ "--parallax-bg": "-10px" },
				{
					"--parallax-bg": "100px",
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: ".first-section",
						start: "top top+=40px",
						end: "bottom top",
						scrub: true,
					},
				},
			);

			// Plants
			gsap.to(".first-section", {
				"--parallaxY-left": "100px",
				"--parallaxY-right": "-150px",
				ease: "none",
				scrollTrigger: {
					trigger: ".first-section",
					start: "top bottom",
					end: "bottom top",
					scrub: true,
				},
			});
		});
	}

	const isUnexpectedPage =
		document.querySelector(".case-studies-unexpected-hero") ||
		document.querySelector(".case-studies-replimune");
	if (isUnexpectedPage && !isLayoutBuilder) {
		const heroSection = document.querySelector(".hero-section");
		let parallaxRange = 200;

		if (heroSection) {
			gsap.fromTo(
				heroSection,
				{ "--parallax-bg": "-10px" },
				{
					"--parallax-bg": `${parallaxRange}px`,
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: heroSection,
						start: "top top+=40px",
						end: "bottom top",
						scrub: true,
					},
				},
			);
		}

		const sections = [
			".first-section",
			".second-section",
			".third-section",
			".next-up-section",
		];
		const sectionParallaxRange = 300;
		sections.forEach((section) => {
			gsap.fromTo(
				section,
				{ "--parallax-bg": "-10px" },
				{
					"--parallax-bg": `${sectionParallaxRange}px`,
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: section,
						start: "top top+=40px",
						end: "bottom top",
						scrub: true,
					},
				},
			);
		});
	}

	if (isPetSecretsPage && !isLayoutBuilder) {
		const mm = gsap.matchMedia();
		const heroSection = document.querySelector(".hero-section");
		gsap.fromTo(
			heroSection,
			{ "--parallax-bg": "0px" },
			{
				"--parallax-bg": "-250px",
				ease: "none",
				immediateRender: false,
				scrollTrigger: {
					trigger: heroSection,
					start: "top top",
					end: "bottom top",
					scrub: true,
				},
			},
		);

		mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
			const theAskImage = document.querySelectorAll(
				"#the-ask > div div:last-of-type img",
			);
			const dogImage = document.querySelectorAll(
				"#the-idea > div > div:first-of-type img",
			);
			const theIdeaImage = document.querySelectorAll(
				"#the-idea > div > div:last-of-type img",
			);

			gsap.fromTo(
				theAskImage,
				{ y: -50 },
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: theAskImage,
						start: "top 90%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);

			gsap.fromTo(
				dogImage,
				{ y: 20 },
				{
					y: -20,
					ease: "none",
					scrollTrigger: {
						trigger: "#the-idea .glass-content",
						start: "top 80%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);

			gsap.fromTo(
				theIdeaImage,
				{ y: -10 },
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: theIdeaImage,
						start: "top 90%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);
		});

		gsap.to(".images-wrapper > div > div", {
			scrollTrigger: {
				trigger: ".images-wrapper",
				start: "top 80%",
				toggleActions: "play none none none",
			},
			y: 0,
			opacity: 1,
			duration: 1,
			ease: "power2.out",
			stagger: 0.3,
		});

		gsap.to(".house-image", {
			y: 20,
			ease: "none",
			immediateRender: false,
			scrollTrigger: {
				trigger: ".house-image",
				start: "top top",
				end: "bottom top",
				scrub: true,
			},
		});
	}

	if (isRedThreadPage && !isLayoutBuilder) {
		const heroSection = document.querySelector(".hero-section");
		gsap.fromTo(
			heroSection,
			{ "--parallax-bg": "0px" },
			{
				"--parallax-bg": "300px",
				ease: "none",
				immediateRender: false,
				scrollTrigger: {
					trigger: heroSection,
					start: "top top",
					end: "bottom top",
					scrub: true,
				},
			},
		);

		const theInsightImage = document.querySelectorAll(
			"the-insight > div div:first-of-type img",
		);
		const theIdeaImage = document.querySelectorAll(
			"#the-idea > div div:last-of-type img",
		);

		gsap.fromTo(
			theInsightImage,
			{ y: -50 },
			{
				y: 0,
				ease: "none",
				scrollTrigger: {
					trigger: theInsightImage,
					start: "top 90%",
					end: "bottom 70%",
					scrub: true,
				},
			},
		);

		gsap.fromTo(
			theIdeaImage,
			{ y: -10 },
			{
				y: 0,
				ease: "none",
				scrollTrigger: {
					trigger: theIdeaImage,
					start: "top 90%",
					end: "bottom 70%",
					scrub: true,
				},
			},
		);

		const mm = gsap.matchMedia();
		mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
			gsap.to(".result-wrapper", {
				y: -200,
				ease: "none",
				immediateRender: false,
				scrollTrigger: {
					trigger: ".result-wrapper",
					start: "top top",
					end: "bottom top",
					scrub: true,
				},
			});
		});
	}

	const isMoveGbsForwardPage =
		document.querySelector(".case-studies-move-gbs-forward") ||
		document.querySelector(".case-studies-annexon");
	if (isMoveGbsForwardPage && !isLayoutBuilder) {
		const mm = gsap.matchMedia();

		mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
			const heroSection = document.querySelector(".first-section");
			gsap.fromTo(
				heroSection,
				{ "--parallax-bg": "0px" },
				{
					"--parallax-bg": "-300px",
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: heroSection,
						start: "top top",
						end: "bottom top",
						scrub: true,
					},
				},
			);

			const theIdeaImage = document.querySelectorAll(
				"#the-idea > div div:last-of-type img",
			);
			gsap.fromTo(
				theIdeaImage,
				{ y: -10 },
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: theIdeaImage,
						start: "top 90%",
						end: "bottom 70%",
						scrub: true,
					},
				},
			);
		});
	}

	const isLeadershipPage = window.location.pathname === "/leadership";
	if (isLeadershipPage) {
		const dissolver = new ImageDissolver(
			document.querySelectorAll(".leadership-image"),
		);

		const mm = gsap.matchMedia();
		mm.add(`(min-width: ${mobileResolution + 1}px)`, () => {
			gsap.utils.toArray(".leadership-item").forEach((item, i) => {
				gsap.to(item, {
					scrollTrigger: {
						trigger: item,
						start: "top 100%+100px",
						toggleActions: "play none none none",
					},
					y: 0,
					opacity: 1,
					duration: 0.6,
					ease: "power2.out",
					delay: i * 0.2,
				});
			});
		});
	}

	const headerContactInfo = document.querySelector(".header-contact-info p");
	const listHeader = document.createElement("li");
	const menuContainerUl = document.querySelector(
		"#block-envivent-main-menu ul",
	);
	const contactInfoClone = headerContactInfo
		? headerContactInfo.cloneNode(true)
		: null;
	listHeader.classList.add("menu-item", "contact-info");
	if (contactInfoClone) {
		listHeader.appendChild(contactInfoClone);
		menuContainerUl.appendChild(listHeader);
	}

	let scrollBefore = 0;
	const saveScrollPosition = () => {
		scrollBefore = lenis.scroll;
	};

	const restoreScrollPosition = () => {
		requestAnimationFrame(() => {
			lenis.scrollTo(scrollBefore, { immediate: true });
		});
	};

	window.addEventListener("resize", saveScrollPosition);
	screen.orientation.addEventListener("change", restoreScrollPosition);


	// External links in the policy copy open in a new tab. The selector was
	// ".privacy-policy a", but .privacy-policy is the page's body class, so it
	// matched every anchor on the page - the nav and the whole footer included -
	// and sent internal links off to new tabs. Scoped to the copy, and gated on
	// origin so mailto, fragments and our own URLs are left alone.
	if (isPrivacyPolicyPage) {
		const links = document.querySelectorAll(".introduction a[href]");

		links.forEach((link) => {
			const href = link.getAttribute("href");
			if (!href || !/^https?:/i.test(href)) {
				return;
			}

			let isExternal = false;
			try {
				isExternal =
					new URL(href, window.location.href).origin !==
					window.location.origin;
			} catch (error) {
				isExternal = false;
			}

			if (isExternal) {
				link.setAttribute("target", "_blank");
				link.setAttribute("rel", "noopener noreferrer");
			}
		});
	}
});
